export default "__VITE_ASSET__Cd0F$$QD__"